import ShopaholicProductList from '../../../js/shopaholic-product-list/shopaholic-product-list';
import UrlGeneration from '@lovata/url-generation';
import LazyLoad from '../../../js/lazy-load';
import Select from '../../form/select/select';

export default new class Showmore {
  constructor() {
    this.obProductListHelper = new ShopaholicProductList();
    this.sFiledName = 'page';
    this.sAttributeName = 'data-page';
    this.sAttributePartial = 'data-partial';
    this.sCatalogListWrapper = 'catalog-list';
    this.sShowmoreContainer = 'showmore__container';
    this.sPaginationContainer = 'pagination';

    this.preLoaderSelector = '.catalog__preloader';

    this.btnShowmore = '_shopaholic-showmore';

    this.handler();
  }

  handler() {
    $(document).on('click', `.${this.btnShowmore}`, (e) => {
      const obButton = $(e.currentTarget);
      const iPage = obButton.attr(this.sAttributeName);
      const partial = obButton.attr(this.sAttributePartial);

      UrlGeneration.init();
      if (iPage === 1) {
        UrlGeneration.remove(this.sFiledName);
      } else {
        UrlGeneration.set(this.sFiledName, [iPage]);
      }

      UrlGeneration.update();
      if (!this.obProductListHelper) {
        return;
      }

      this.updateCatalogAjax(iPage, partial).send();
    });
  }

  updateCatalogAjax(iPage, partial) {
    const obListHelper = new ShopaholicProductList();

    obListHelper.setAjaxRequestCallback((obRequestData) => {
      /* eslint-disable  no-param-reassign */
      obRequestData.update = {
        [partial]: `@.${this.sCatalogListWrapper}`,
        'common/pagination/showmore': `.${this.sShowmoreContainer}`,
        // 'common/pagination/pagination': `.${this.sPaginationContainer}`,
      };
      obRequestData.complete = () => {
        LazyLoad.update();
        //Select.checkSelect();

        const paginationLink = document.querySelector(`.pagination__link[data-page="${iPage}"]`);
        paginationLink.classList.add('pagination__link_current');
        paginationLink.removeAttribute('href');
      };
      obRequestData.loading = this.preLoaderSelector;
      /* eslint-enable */

      return obRequestData;
    });

    return obListHelper;
  }
}();
